<template>
  <div>
    <corner-ribbon :text="ribbonText" v-if="ribbonText" />
    <pno-navigation />
    <div id="main">
      <app-view :key="$route.fullPath"></app-view>
    </div>
    <pno-footer />
  </div>
</template>

<script>
  import PnoNavigation from '@/components/PnoNavigation.vue'
  import PnoFooter from '@/components/PnoFooter.vue'
  import '@/assets/main.scss'
  import { mapState } from 'vuex'
  import CornerRibbon from '@/components/CornerRibbon.vue'

  export default {
    components: { PnoNavigation, PnoFooter, CornerRibbon },
    computed: {
      ...mapState('meta', ['title', 'description', 'image', 'imageWidth', 'imageHeight']),
      ribbonText: function () {
        return window.envConfig.UI_ENV
      },
    },
    metaInfo() {
        return {
            title: this.title,
            meta: [
                {vmid: 'description', name: 'description', content: this.description},

                {vmid: 'twitter:title', name: 'twitter:title', content: this.title},
                {vmid: 'twitter:description', name: 'twitter:description', content: this.description},
                {vmid: 'twitter:site', name: 'twitter:site', content: '@pnorental'},
                {vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image'},
                {vmid: 'twitter:image', name: 'twitter:image', content: this.image},

                {vmid: 'og:title', property: 'og:title', content: this.title},
                {vmid: 'og:description', property: 'og:description', content: this.description},
                {vmid: 'og:url', property: 'og:url', content: this.title},
                {vmid: 'og:image', property: 'og:image', content: this.image},
                {vmid: 'og:image:width', property: 'og:image:width', content: 1200},
                {vmid: 'og:image:height', property: 'og:image:height', content: 630},

            ]
        }
    },
  }
</script>
